import '../app/main';
import * as bundle from 'bundle';
import UpdateDetails from 'portlets/parx-theme/update-details/updatedetails.model';

bundle.registerPortlets({
    'portlets_update_details_update_details_model': UpdateDetails,
});
